import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import VueQuillEditor from 'vue-quill-editor'  //引入富文本编译器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


//样式重置
import '@/assets/css/reset.css'
import '@/assets/css/global.css'

// Element-ui (打包时注释)
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
Vue.use(ElementUI)
Vue.use(ElementUI, { size: 'small', zIndex: 1000 });

// axios
import $http from '@/api'
Vue.prototype.$http = $http;


//过滤器
import '@/assets/js/filters.js'

Vue.config.productionTip = false

Vue.use(VueQuillEditor);
Vue.directive('title', {//单个修改标题
  inserted: function (el) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
